import { API_BASE_URL } from "../config/apiConfig";


const fetchAPI = async (endpoint, method = "GET", body = null, token = null) => {
    const headers = {
        "Content-Type": "application/json",
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const options = {
        method,
        headers,
    };

    if (body) {
        options.body = JSON.stringify(body);
    }

    const response = await fetch(`${API_BASE_URL}/api/admin/${endpoint}`, options);
    return response.json();
};


// Register Admin
export const registerAdmin = (data) => fetchAPI("register", "POST", data);

// Login Admin
export const loginAdmin = (data) => fetchAPI("login", "POST", data);

// Get All Admins
export const getAdmins = (token) => fetchAPI("", "GET", null, token);

export const getAllAnswers = (token) => fetchAPI("answers/all", "GET", null, token)

// Get Single Admin
export const getSingleAdmin = (id, token) => fetchAPI(`${id}`, "GET", null, token);

// Update Admin Details
export const updateAdminDetails = (id, data, token) => fetchAPI(`${id}`, "PUT", data, token);

// Update Profile Image
export const updateProfileImage = async (id, formData, token) => {
    const response = await fetch(`${API_BASE_URL}/api/admin/profile-image/${id}`, {
        method: "PATCH",
        headers: {
            "Authorization": `Bearer ${token}`,
        },
        body: formData,
    });

    return response.json();
};


// Delete Profile Image
export const deleteProfileImage = (id, token) => fetchAPI(`${id}/delete-profile-image`, "DELETE", null, token);

// Forgot Password (Send OTP)
export const sendForgotPasswordEmail = (data) => fetchAPI("forgot-password", "POST", data);

// Verify OTP
export const verifyOTP = (data) => fetchAPI("verify-otp", "POST", data);

// Reset Password
export const resetPassword = (data) => fetchAPI("reset-password", "POST", data);

// Generate New OTP
export const generateNewOtp = (data) => fetchAPI("generate-new-otp", "POST", data);

// Reports
export const getReportsSummary = (token) =>
    fetchAPI("reports/summary", "GET", null, token);
export const getTopicsOverview = (token) =>
    fetchAPI("reports/topics-overview", "GET", null, token);
export const getTeachersOverview = (token) =>
    fetchAPI("reports/teachers", "GET", null, token);
export const getTeacherClasses = (teacherId, token) =>
    fetchAPI(`reports/teachers/${teacherId}/classes`, "GET", null, token);
